import * as Sentry from '@sentry/vue'
import { metaTagContent } from '@/helpers/documentHelpers.js'

// Crawler-rendered pages produce expected, non-actionable errors (e.g. 403s on
// endpoints bots are blocked from); drop their events instead of reporting.
const CRAWLER_USER_AGENT =
  /bot|crawl|spider|slurp|facebookexternalhit|bingpreview|chatgpt-user|perplexity|anthropic-ai|ahrefs/i

function initSentry(app, router = null, user = null) {
  const dsn = metaTagContent('dsn')

  if (!dsn) {
    console.warn('DSN not found')
    return null
  }

  const browserTracingOptions = {}
  if (router) browserTracingOptions.router = router
  if (user) Sentry.setUser(user)

  return Sentry.init({
    app,
    dsn,
    debug: false,
    sendDefaultPii: true,
    ignoreErrors: [
      /^reCAPTCHA Timeout/, // Non-actionable Google reCAPTCHA network errors
      /window\.webkit\.messageHandlers/, // iOS WebKit bridge calls from third-party scripts
      /ResizeObserver loop/, // Benign browser warning, not a real error
    ],
    integrations: [
      Sentry.vueIntegration({
        tracingOptions: {
          trackComponents: true,
        },
      }),
      // TODO: enable tracing for multiple vue apps
      // Sentry.browserTracingIntegration(browserTracingOptions),

      // excluding error, because it's already captured by Sentry.vueIntegration
      Sentry.consoleLoggingIntegration({ levels: ['debug', 'info', 'warn'] }),
    ],
    _experiments: { enableLogs: true },
    beforeSend(event) {
      if (typeof navigator === 'undefined') return event
      return CRAWLER_USER_AGENT.test(navigator.userAgent) ? null : event
    },
    tracesSampleRate: 0.7,
    tracePropagationTargets: ['vite', 'localhost', 'tourhero.com', 'staging.tourhero.com', /^\//],
  })
}

export { initSentry }
